// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about_aboutSection__QNY6i {
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
}

.about_aboutContent__OjncZ {
    gap: 16px;
    margin-bottom: 20px;
    text-align: center;
    width: 520px;
}

.about_aboutContent__OjncZ h2 {
    color: #F4CE14;
}

.about_aboutContent__OjncZ span {
    color: #495E57;
    display: inline-block;
    font-family: 'Markazi Text', serif;
    font-size: clamp(18pt, 5vw, 30pt);
    font-weight: normal;
    margin-bottom: 25px;
}

.about_aboutContent__OjncZ p {
    padding: 0 10%;
}

.about_aboutImageWrapper__fa550 {
    margin: 0 auto;
}

.about_aboutImage__cShro {
    height: 376px;
    overflow: hidden;
    width: 258px;
}

.about_aboutImage__cShro:nth-child(1) {
    margin: 0 0 20px;
}

.about_aboutImage__cShro:nth-child(2) {
    margin: 0;
    position: relative;
    z-index: 0;
}

.about_aboutImage__cShro:nth-child(1) img {
    margin-left: -93px;
    transform: scaleX(-1);
    width: 581px;
}

.about_aboutImage__cShro:nth-child(2) img {
    margin-left: -297px;
    margin-top: -36px;
    width: 638px;
}

@media (min-width: 938px) {
    .about_aboutSection__QNY6i {
        align-items: flex-start;
        flex-direction: row;
    }

    .about_aboutContent__OjncZ {
        margin-bottom: 0;
        text-align: left;
    }

    .about_aboutImageWrapper__fa550 {
        margin: unset;
        position: relative;
        width: 500px;
    }

    .about_aboutImage__cShro:nth-child(1) {
        margin-top: 50px;
    }

    .about_aboutImage__cShro:nth-child(2) {
        margin-left: 207px;
        position: absolute;
        top: 0;
        z-index: 1;
    }
}

@media (min-width: 1615px) {
    .about_aboutContent__OjncZ p {
        padding: 0;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/Home/About/about.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kCAAkC;IAClC,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,MAAM;QACN,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".aboutSection {\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.aboutContent {\n    gap: 16px;\n    margin-bottom: 20px;\n    text-align: center;\n    width: 520px;\n}\n\n.aboutContent h2 {\n    color: #F4CE14;\n}\n\n.aboutContent span {\n    color: #495E57;\n    display: inline-block;\n    font-family: 'Markazi Text', serif;\n    font-size: clamp(18pt, 5vw, 30pt);\n    font-weight: normal;\n    margin-bottom: 25px;\n}\n\n.aboutContent p {\n    padding: 0 10%;\n}\n\n.aboutImageWrapper {\n    margin: 0 auto;\n}\n\n.aboutImage {\n    height: 376px;\n    overflow: hidden;\n    width: 258px;\n}\n\n.aboutImage:nth-child(1) {\n    margin: 0 0 20px;\n}\n\n.aboutImage:nth-child(2) {\n    margin: 0;\n    position: relative;\n    z-index: 0;\n}\n\n.aboutImage:nth-child(1) img {\n    margin-left: -93px;\n    transform: scaleX(-1);\n    width: 581px;\n}\n\n.aboutImage:nth-child(2) img {\n    margin-left: -297px;\n    margin-top: -36px;\n    width: 638px;\n}\n\n@media (min-width: 938px) {\n    .aboutSection {\n        align-items: flex-start;\n        flex-direction: row;\n    }\n\n    .aboutContent {\n        margin-bottom: 0;\n        text-align: left;\n    }\n\n    .aboutImageWrapper {\n        margin: unset;\n        position: relative;\n        width: 500px;\n    }\n\n    .aboutImage:nth-child(1) {\n        margin-top: 50px;\n    }\n\n    .aboutImage:nth-child(2) {\n        margin-left: 207px;\n        position: absolute;\n        top: 0;\n        z-index: 1;\n    }\n}\n\n@media (min-width: 1615px) {\n    .aboutContent p {\n        padding: 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboutSection": `about_aboutSection__QNY6i`,
	"aboutContent": `about_aboutContent__OjncZ`,
	"aboutImageWrapper": `about_aboutImageWrapper__fa550`,
	"aboutImage": `about_aboutImage__cShro`
};
export default ___CSS_LOADER_EXPORT___;
